import { z } from 'zod';
import { BuyerTypeSchema, InvoiceStatusSchema } from './enums.schema.js';
// Phase 10a — Invoice header read shape (admin + buyer views).
// All money fields integer cents per 10a-1 lock. JSON serialization
// is straightforward (no Decimal wrapper).
export const InvoiceResponseSchema = z.object({
    id: z.string().uuid(),
    invoiceNumber: z.string().nullable(),
    buyerType: BuyerTypeSchema,
    facilityId: z.string().uuid().nullable(),
    homecareClientId: z.string().uuid().nullable(),
    status: InvoiceStatusSchema,
    subtotalCents: z.number().int().min(0),
    hstCents: z.number().int().min(0),
    totalCents: z.number().int().min(0),
    amountPaidCents: z.number().int().min(0),
    currency: z.literal('CAD'),
    cycleStartDate: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/)
        .nullable(),
    cycleEndDate: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/)
        .nullable(),
    issuedAt: z.string().datetime().nullable(),
    dueDate: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/)
        .nullable(),
    paidAt: z.string().datetime().nullable(),
    voidedAt: z.string().datetime().nullable(),
    voidReason: z.string().nullable(),
    shiftRequestId: z.string().uuid().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const InvoiceListResponseSchema = z.object({
    items: z.array(InvoiceResponseSchema),
    totalCount: z.number().int().min(0),
    page: z.number().int().positive(),
    pageSize: z.number().int().positive(),
});
//# sourceMappingURL=invoice.schema.js.map